
import { ref, onMounted, onUnmounted, Ref } from '@vue/composition-api';
import MainLayoutInfo from '@/data/layout/MainLayoutInfo';


function isScrolledToBottom(baseElem?: Ref<HTMLDivElement|null>) {

  const tolerance = 100;
  const bottom = baseElem?.value?.getBoundingClientRect().bottom;
  if(bottom) {
    return bottom < (window.innerHeight - tolerance);
  }
  else {
    const scrollPos = window.scrollY + window.innerHeight;
    return scrollPos + tolerance >= window.document.documentElement.scrollHeight;
  }
}

export default function useMainLayout(baseElem?: Ref<HTMLDivElement|null>) {

  const scrollWidth = window.document.documentElement.scrollWidth;
  // Hint: initially the scroll width might be incorrect because
  // of sideeffects of the parent element of Corporate tube (Magnolia component).
  const actualWidth = scrollWidth > innerWidth * 5 ?  window.innerWidth : scrollWidth;

  const layoutType = ref(MainLayoutInfo.getLayoutType(actualWidth));
  const fullWidth = ref(actualWidth);
  const scrolledToBottom = ref(isScrolledToBottom());

  const scrollIntoView = () => {
    baseElem?.value?.scrollIntoView();
    window.scrollBy(0, -50);
  }

  const onScroll = () => {
    const _isScrolledToBottom = isScrolledToBottom(baseElem);
    if(scrolledToBottom.value != _isScrolledToBottom) {
      scrolledToBottom.value = _isScrolledToBottom;
    }
  }

  const onResize = () => {
    fullWidth.value = window.document.documentElement.scrollWidth;
    const localLayoutType = MainLayoutInfo.getLayoutType(fullWidth.value);
    if(localLayoutType !== layoutType.value) {
      layoutType.value = localLayoutType;
    }
    onScroll();
  };

  onMounted(() => {
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onScroll);
  });
  onUnmounted(() => {
    window.removeEventListener('resize', onResize);
    window.removeEventListener('scroll', onScroll);
  });

  return {
    layoutType,
    fullWidth,
    scrolledToBottom,
    scrollIntoView
  };
}